export interface IWindowState {
  // Window state is stateless - all actions are side effects only
}

export const initialState: IWindowState = {
  // Empty initial state as this feature only handles side effects
};
